import $ from "jquery";

export type FormDataMap = Record<string, any>;

export function fillFormFromData(
    $form: JQuery<HTMLElement>,
    data: FormDataMap,
    allowedKeys: string[] = []
): void {
    Object.keys(data).forEach((key: string) => {

        if (allowedKeys.length && !allowedKeys.includes(key)) return;

        const $field = $form.find(`[name="${key}"]`);
        if (!$field.length) return;

        const type = $field.attr('type');

        if (type === 'checkbox') {
            ($field as JQuery<HTMLInputElement>)
                .prop('checked', Boolean(data[key]))
                .trigger('change');
        }
        else if ($field.is('select')) {
            ($field as JQuery<HTMLSelectElement>)
                .val(data[key])
                .trigger('change');
        }
        else {
            ($field as JQuery<HTMLInputElement | HTMLTextAreaElement>)
                .val(data[key] ?? '');
        }
    });
}